import React, { FC } from 'react'
import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  theatricalSlug: string
  isOpen: boolean
  onClose: () => void
}
export const GiveawayModal: FC<Props> = ({ theatricalSlug, isOpen, onClose }) => {
  const { t } = useTranslate('tickets')

  if (theatricalSlug === slugs.kingOfKings) {
    return (
      <Modal
        backgroundScreenColor="black"
        isOpen={isOpen}
        onClose={onClose}
        panelClasses="w-full !max-w-[361px] md:!max-w-[600px] !overflow-visible !bg-[#141721] shadow-dark-4 rounded-3xl !p-0 relative text-left"
        transition="appear"
        className="z-[99999]"
        childWrapperClassName="!m-0"
      >
        <div className="relative h-[200px] w-full rounded-t-2xl md:h-[300px]">
          <Image src="/v1741926757/tkok-trip-img-only-02n_o9ibme" alt="" fill className="rounded-t-2xl object-cover" />
          <Image
            src="/v1741971035/king-of-kings_character-render_jesus-d-2_mutlk9.webp"
            alt=""
            width={148.1}
            height={300}
            className="absolute -top-6 left-1/2 -translate-x-1/2"
          />
          <div
            style={{ background: 'linear-gradient(180deg, rgba(20, 23, 33, 0) 0%, #141721 100%)' }}
            className="absolute inset-x-0 bottom-0 h-[72px] w-full bg-[#141721]  md:h-[104px]"
          />
        </div>

        <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-white p-[10px]" onClick={onClose}>
          <CloseIcon color="core-gray-950" size={20} />
        </div>

        <div className="relative z-40 rounded-b-3xl bg-[#141721] p-6 !pr-[64px] !pt-8 md:p-10 md:!pr-[95px] md:!pt-6">
          <Text weight="bold" className="photon-title-lg md:!photon-heading-md block !text-[#F1B420]">
            {t('tkokEnterToWin', 'Buy Tickets for The King of Kings and Enter to Win a London & Holy Land Trip!')}
          </Text>

          <Text color="white" className="photon-paragraph-sm md:photon-paragraph-md mt-2 block md:mt-4">
            {t(
              'tkokEnterToWinDescriptionV2',
              'See The King of Kings in theaters April 11th and enter to win a 10-day journey through historic London and the Holy Land. Walk where Jesus walked and Charles Dickens!',
            )}
          </Text>

          <Button className="mr-auto mt-8 w-fit" variant="white" onClick={onClose}>
            {t('getShowtimes', 'Get Showtimes')}
          </Button>

          <Image
            src="https://images.angelstudios.com/image/upload/v1741967646/walter-willia_mkhxqi"
            width={198}
            height={263}
            alt=""
            className="absolute bottom-4 right-2 h-[155px] w-[117px] md:-right-6 md:bottom-6 md:!h-[263px] md:!w-[198px]"
          />
        </div>
      </Modal>
    )
  }

  if (theatricalSlug === slugs.theLastRodeo) {
    return (
      <Modal
        backgroundScreenColor="black"
        isOpen={isOpen}
        onClose={onClose}
        panelClasses="w-full !max-w-[361px] md:!max-w-[600px] !overflow-visible !bg-[#E5DFD3] shadow-dark-4 rounded-3xl !p-0 relative text-left"
        transition="appear"
        className="z-[99999]"
        childWrapperClassName="!m-0"
      >
        <div className="relative h-[200px] w-full rounded-t-2xl md:h-[300px]">
          <Image
            src="/v1743120060/the-last-rodeo/truck-trailer-img-01.webp"
            alt=""
            fill
            className="rounded-t-2xl object-cover"
          />
          <div
            style={{ background: 'linear-gradient(180deg, rgba(20, 23, 33, 0) 0%, #141721 100%)' }}
            className="absolute inset-x-0 bottom-0 h-[72px] w-full bg-[#E5DFD3]  md:h-[104px]"
          />
        </div>

        <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-white p-[10px]" onClick={onClose}>
          <CloseIcon color="core-gray-950" size={20} />
        </div>

        <div className="relative z-40 rounded-b-3xl bg-[#E5DFD3] p-6 !pr-[64px] !pt-8 md:p-10 md:!pr-[95px] md:!pt-6">
          <Text weight="bold" className="photon-title-lg md:!photon-heading-md block !text-[#D7300F]">
            {t('rodeoEnterToWin', 'Buy Tickets for The Last Rodeo and enter to to win a $350K Adventure Package')}
          </Text>

          <Text color="black" className="photon-paragraph-sm md:photon-paragraph-md mt-2 block md:mt-4">
            {t(
              'rodeoEnterToWinDescriptionV2',
              'See The Last Rodeo in theaters May 23 for a chance to win a $350K Adventure Package featuring a luxury trailer, $100K in Bitcoin, a Ford F150 Raptor, and more.',
            )}
          </Text>

          <Button className="mr-auto mt-8 w-fit" variant="core-gray-900" onClick={onClose}>
            {t('getShowtimes', 'Get Showtimes')}
          </Button>

          {/*<Image*/}
          {/*  src="https://images.angelstudios.com/image/upload/v1741967646/walter-willia_mkhxqi.png"*/}
          {/*  width={198}*/}
          {/*  height={263}*/}
          {/*  alt=""*/}
          {/*  className="absolute bottom-4 right-2 h-[155px] w-[117px] md:-right-6 md:bottom-6 md:!h-[263px] md:!w-[198px]"*/}
          {/*/>*/}
        </div>
      </Modal>
    )
  }

  return null
}
